import { Link } from "react-router-dom";
import ServiceMenu from "../partials/Menu/Service";

const menuData = [
  {
    title: "Who we are",
    to: "/about",
    id: 1,
  },
  {
    title: "What we do",
    to: "#",
    subMenu: <ServiceMenu />,
    id: 2,
  },
  {
    title: "Blogs",
    to: "#",
    id: 2,
  },
  {
    title: "Our Products",
    to: "#",
    id: 3,
  },
  {
    title: "Connect",
    to: "/contact",
    id: 4,
  },
];

function Navigation({ className }) {
  return (
    <>
      <div className={`restly-header-main-menu ${className || ""}`}>
        {
          <ul>
            {menuData.map(({ title, to, id, subMenu }) => (
              <li key={id}>
                <Link to={to}>
                  {title} {subMenu && <i className="fa fa-angle-down" />}
                </Link>
                {subMenu && <div className="sub-menu">{subMenu}</div>}
              </li>
            ))}
          </ul>
        }
      </div>
    </>
  );
}

export default Navigation;
